import { AfterViewInit, Component, EventEmitter, Inject, Input, NgZone, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { ResponseService, WindowRef } from '@portals/core';
import { NotificationsResponseComponent } from '../notifications-response';
import { HotToastService } from '@ngneat/hot-toast';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { CollectiblesState } from '@portals/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AWSUploadService, Channel, Notification, ThemeType } from '@portals/api';
import { fadeIn, fadeOut, RESPONSE_TYPES } from '@portals/utils';

@Component({
	selector: 'portals-video-recorder',
	templateUrl: './video-recorder.component.html',
	styleUrls: ['./video-recorder.component.scss'],
	animations: [fadeIn, fadeOut],
})
export class VideoRecorderComponent extends NotificationsResponseComponent implements AfterViewInit, OnDestroy {
	@Input() override notification!: Notification;
	@Input() override channel!: Channel;
	@Input() override audioMode!: boolean;
	@Input() override activeScreen!: RESPONSE_TYPES;
	@Input() override startAnimation = false;
	@Input() override finishedResponding = false;
	@Input() override isRecording = false;
	@Input() override setViewComplete = false;
	@Output() setActiveScreen: EventEmitter<RESPONSE_TYPES> = new EventEmitter<RESPONSE_TYPES>();
	@Output() closeModal = new EventEmitter<any>();
	theme?: ThemeType;
	constructor(protected override ngZone: NgZone, protected override toast: HotToastService, protected override location: Location, protected override router: Router, protected override cookies: CookieService, protected awsUpload: AWSUploadService, protected override collectibleState: CollectiblesState, protected override renderer: Renderer2, protected override deviceService: DeviceDetectorService, protected override window: WindowRef, protected override responseService: ResponseService) {
		super(ngZone, toast, location, router, cookies, awsUpload, collectibleState, renderer, deviceService, window, responseService);
		/* Set states for streaming */
		super.mediaConstraints = {
			/* Request Video */
			video: {
				height: this.isLandscape ? (deviceService.isDesktop() ? 650 : 1920) : deviceService.isDesktop() ? 370 : 1080,
				width: this.isLandscape ? (deviceService.isDesktop() ? 370 : 1080) : deviceService.isDesktop() ? 650 : 1920,
				facingMode: 'user',
			},
			/* Request Audio */
			audio: {
				noiseSuppression: true,
				echoCancellation: true,
			},
		};
	}

	ngAfterViewInit(): void {
		this.audioMode = false;
		super.initView();
	}
	getBackgroundColorClass() {
		if (this.theme && this.theme.background_color) {
			return { background: this.theme.background_color, 'background-color': this.theme.background_color };
		} else {
			// return { background: '#491176' };
			return {
				'background-color': 'transparentize(#180225, 0.1)',
			};
		}
	}
	ngOnDestroy() {
		this.videoUIRef?.nativeElement?.srcObject?.getTracks().forEach((track: any) => track.stop());
		super.ngOnDestroy();
	}
}
